import { CountryInfo } from "../countries.types";

export const $BillingCountriesModuleName = "billingCountries";

export type TBillingCountriesState = { countries: Array<CountryInfo> };
